import axios from "axios";
import Config from "../utils/Config";

class LeaveService{

    config = {
        headers: {
            Authorization: "",
            CompanyId: "",
        },
    };

    //set access token
    setAccessToken(accessToken, companyId) {
        this.config.headers.Authorization = accessToken;
        this.config.headers.CompanyId = companyId;
    }

    //get all leave data by user detail id
    async getLeavesByUserDetailsId (userDetailsId, companyId, accessToken){
        this.setAccessToken(accessToken, companyId);
        
        const data = await axios.get(
            Config.BACKEND_URL + `/api/leave/${userDetailsId}`,
            this.config
          )
          return data.data;
      }

    //insert leave data
    async createLeaves(formData, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);

        const data = await axios.post(
          Config.BACKEND_URL + "/api/leave",
          formData,
          this.config
        )
        return data.data;
      }

    //update leave data
    async updateLeaves(formData, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);
    
        const data = await axios.post(
          Config.BACKEND_URL + "/api/leave",
          formData,
          this.config
        )
        return data.data;
      }

    //delete leave data
    async deleteLeaves(formData, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);
        
        const data = await axios.post(
          Config.BACKEND_URL + "/api/leave/delete",
          formData,
          this.config
        )
        return data.data;
      }

    //leave management "Yes" button disable based on availability of leave applier signatories
    async getSignatoryAvailabilityByUserId (userDetailsId, companyId, accessToken){
      this.setAccessToken(accessToken, companyId);
      
      const data = await axios.get(
          Config.BACKEND_URL + `/api/signatories/checkSignatoryAvailability/${userDetailsId}`, ///api/signatories/checkSignatoryAvailability/{userId}
          this.config
        )
        return data.data;
    }

    //signatory confirmation
    async getSignatoryConfirmation(formData, companyId, accessToken) {
      this.setAccessToken(accessToken, companyId);
      
      const data = await axios.post(
        Config.BACKEND_URL + "/api/leave/signatoryConfirmation", ///api/leave/signatoryConfirmation
        formData,
        this.config
      )
      return data.data;
    }
};

export default new LeaveService();